<script lang="ts" setup>
import { defineProps, withDefaults } from 'vue';

const props = withDefaults(
  defineProps<{
    loading?: boolean
    type: 'cancel' | 'confirm'
    onClick?: () => void
  }>(),
  {},
)
</script>
<template>
  <el-button v-if="props.type === 'cancel'" class="btn-footer btn-cancel" type="primary" plain :loading="props.loading"
    @click="props.onClick">
    {{ $t('form.cancel') }}
  </el-button>
  <el-button v-if="props.type === 'confirm'" class="btn-footer btn-confirm" type="primary" :loading="props.loading"
    @click="props.onClick">
    {{ $t('form.confirm') }}
  </el-button>
</template>
<style lang="scss" scoped></style>
